import React from 'react';
import { DynamicCategoryStep } from './DynamicCategoryStep';

export const PreparationStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="preparation" />
);

export const DemolitionStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="demolition" />
);

export const GrosOeuvreStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="gros-oeuvre" />
);

export const VRDStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="vrd" />
);

export const IsolationStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="isolation" />
);

export const CloisonsStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="cloisons" />
);

export const TechniqueStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="technique" />
);

export const SanitaireStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="sanitaire" />
);

export const RevetementsStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="revetements" />
);

export const MenuiserieStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="menuiserie" />
);

export const FinitionsStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="finitions" />
);

export const ExterieursStepWrapper: React.FC<any> = (props) => (
  <DynamicCategoryStep {...props} categoryId="exterieurs" />
);
